// After any successful sign-in the access check is re-run; the App drops
// from the door to the shell when auth/me answers 200.
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../api/queryKeys';

export function useAuthRefresh(): () => void {
  const queryClient = useQueryClient();
  return useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: queryKeys.authMe() });
  }, [queryClient]);
}
